// extracted by mini-css-extract-plugin
export var text = "Text-module--text--3UtBe";
export var text_inline = "Text-module--text_inline--2JQ2U";
export var text_inlineBlock = "Text-module--text_inlineBlock--29LiB";
export var text_alignLeft = "Text-module--text_alignLeft--2EHmS";
export var text_alignRight = "Text-module--text_alignRight--2ubU9";
export var text_alignCenter = "Text-module--text_alignCenter--ky7kM";
export var text_card_big_title = "Text-module--text_card_big_title--jobSP";
export var text_h1 = "Text-module--text_h1--2hnhX";
export var text_h2 = "Text-module--text_h2--2PHDg";
export var text_h3 = "Text-module--text_h3--2cegk";
export var text_block_title = "Text-module--text_block_title--2rRBd";
export var text_card_description = "Text-module--text_card_description--3Tk8h";
export var text_card_title = "Text-module--text_card_title--29jZy";
export var text_system = "Text-module--text_system--1fv8s";
export var text_description = "Text-module--text_description--2Ptsz";
export var text_note = "Text-module--text_note--qaAjr";
export var text_system_description = "Text-module--text_system_description--1t5Fw";
export var text_main = "Text-module--text_main--2fH-P";
export var text_button = "Text-module--text_button--T9iup";
export var text_sub_system = "Text-module--text_sub_system--1Ijcb";
export var text_sub = "Text-module--text_sub--3cRWp";
export var text_name = "Text-module--text_name--3OchV";
export var text_weight400 = "Text-module--text_weight-400--aBQbo";
export var text_weight_500 = "Text-module--text_weight_500--khVaq";
export var text_weight_700 = "Text-module--text_weight_700--A-6KH";
export var text_weight_800 = "Text-module--text_weight_800--15D98";
export var text_ellipsis = "Text-module--text_ellipsis--UrFI6";
export var text_color_grey = "Text-module--text_color_grey--ceT7Q";
export var text_elementButton = "Text-module--text_elementButton--1v-3t";